exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".skillsetStandardLabel{display:inline-block;font-size:.8em;font-weight:400;color:#888}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/questions/skillset_standard_label.scss
// module id = 1525
// module chunks = 0